import Cookies from "js-cookie";
import axios from "axios";
import { isAgencySocialSite, socialPageOrigin } from "@/config/agencyRuntime";
const VUEX_STORAGE_KEY = "vuex";
let authRedirectInFlight = false;
/** Đang chuyển sang login — chặn gọi redirect/API lặp. */
export function isAuthRedirectInFlight() {
    return authRedirectInFlight;
}
export function markAuthRedirectInFlight() {
    authRedirectInFlight = true;
}
export function hasStoredAccessToken() {
    const t = localStorage.getItem("access_token");
    return !!(t && String(t).trim() !== "");
}
export function clearClientSession() {
    window.isAuthenticated = false;
    Cookies.remove("access_token");
    Cookies.remove("user_id");
    localStorage.removeItem("access_token");
    localStorage.removeItem("user_id");
    try {
        sessionStorage.removeItem("chat_launch_notice");
    }
    catch {
        /* ignore */
    }
    localStorage.removeItem(VUEX_STORAGE_KEY);
    axios.defaults.headers.common.Authorization = ``;
    const win = window;
    win.__SOCIAL_SSO_CONFIG__ = null;
    win.__SOCIAL_SSO_ENABLED__ = false;
}
/**
 * Chuyển thẳng tới login (không reload trên trang đang bảo vệ).
 * resolveLoginPath: async () => string — ví dụ SSO-only → IdP.
 */
export function redirectToLoginPage(resolveLoginPath, options) {
    if (!options?.force && authRedirectInFlight) {
        return;
    }
    markAuthRedirectInFlight();
    const fallback = isAgencySocialSite() ? "/agency-login" : "/login";
    const go = (path) => {
        if (typeof window !== "undefined") {
            const target = path.startsWith("http")
                ? path
                : `${socialPageOrigin()}${path.startsWith("/") ? path : `/${path}`}`;
            window.location.replace(target);
        }
    };
    if (!resolveLoginPath) {
        go(fallback);
        return;
    }
    Promise.resolve(resolveLoginPath())
        .then((path) => go(path || fallback))
        .catch(() => go(fallback));
}
